/* global archiveUrl deleteArchiveReportUrl downloadReportUrl checkStatusUrl */
/* global isVikEnabled isWorkforceModuleEnabled tab channelName generateReportUrl fetchReportUrl emailReportUrl budgetVersions scopeOptionsByBudget currentBudgetId */
/* global previewCachedUrl previewRefreshUrl previewShowUrl reportCentrePruningDays */
/* global showBudgetReviewUrl editBudgetReviewUrl deleteBudgetReviewUrl deleteBudgetReviewActionUrl */

import React, { useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ArchiveBudgetByDimensionReport from './ArchiveBudgetByDimensionReport';
import { BudgetByDimensionReportProvider } from './context/BudgetByDimensionReportContext';
import GenerateBudgetByDimensionReport from './GenerateBudgetByDimensionReport';

import Tabs, { RenderStrategyOnVisit } from 'CommonComponents/Tabs';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

const GENERATE_TAB_ID = 'budget-by-event-report---generate-report';
const ARCHIVE_TAB_ID = 'budget-by-event-report---archive';

export default function BudgetByEventReport({ initialTab }) {
    const [activeTab, setActiveTab] = useState(initialTab === 'archived_report' ? ARCHIVE_TAB_ID : GENERATE_TAB_ID);

    const tabs = useMemo(
        () => [
            {
                id: GENERATE_TAB_ID,
                title: $t('Generate Report'),
                content: () => <GenerateBudgetByDimensionReport archiveTabId={ARCHIVE_TAB_ID} />,
            },
            {
                id: ARCHIVE_TAB_ID,
                title: $t('Archive'),
                content: () => <ArchiveBudgetByDimensionReport />,
            },
        ],
        [],
    );

    return <Tabs tabs={tabs} activeTab={activeTab} onTabActivate={setActiveTab} renderStrategy={RenderStrategyOnVisit} maxScreenHeight />;
}

if (document.getElementById('BudgetByEventReport')) {
    var rootEl = document.getElementById('BudgetByEventReport');
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <BudgetByDimensionReportProvider
                    generateReportUrl={generateReportUrl}
                    fetchReportUrl={fetchReportUrl}
                    previewCachedUrl={previewCachedUrl}
                    previewRefreshUrl={previewRefreshUrl}
                    previewShowUrl={previewShowUrl}
                    emailReportUrl={emailReportUrl}
                    fetchArchivedReportsUrl={archiveUrl}
                    deleteArchivedReportUrl={deleteArchiveReportUrl}
                    downloadArchivedReportUrl={downloadReportUrl}
                    checkStatusUrl={checkStatusUrl}
                    showBudgetReviewUrl={showBudgetReviewUrl}
                    editBudgetReviewUrl={editBudgetReviewUrl}
                    deleteBudgetReviewUrl={deleteBudgetReviewUrl}
                    deleteBudgetReviewActionUrl={deleteBudgetReviewActionUrl}
                    budgetVersions={budgetVersions}
                    scopeOptionsByBudget={scopeOptionsByBudget}
                    currentBudgetId={currentBudgetId}
                    isVikEnabled={isVikEnabled}
                    isWorkforceModuleEnabled={isWorkforceModuleEnabled}
                    channelName={channelName}
                    pruningDays={reportCentrePruningDays}
                    dimension="event"
                >
                    <BudgetByEventReport initialTab={tab} />
                </BudgetByDimensionReportProvider>
            </ConfirmationModalProvider>
        </App>,
        rootEl,
    );
}
